// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m6NVd","icon":"styles_icon__MeW5W"};